<template>
  <v-layout
    wrap
  >
    <v-navigation-drawer
      v-model="drawer"
      fixed
      temporary
      right
    >
      <v-list class="pa-1">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon large>account_circle</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ profile && `${profile.first_name} ${profile.last_name}` }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list class="pt-0">
        <v-divider></v-divider>

        <v-list-tile @click="logout">
          <v-list-tile-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>登出</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar flat>
      <v-toolbar-title><a style="text-decoration: none;color: black;" href="javascript: void(0)" @click="$router.push({ name: 'index' })">蘋果傢俬</a></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-side-icon @click="drawer = !drawer"></v-toolbar-side-icon>
    </v-toolbar>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12 sm10 lg6 offset-sm1 offset-lg3>
          <div class="main-action-buttons">
            <div class="button-container">
              <div class="button green lighten-5" @click="$router.push({ name: 'new' })">
                <div><div><v-icon>cloud_upload</v-icon></div>開單</div>
              </div>
            </div>
          </div>
          <transition name="page" mode="out-in">
            <keep-alive include="main-view">
              <router-view :key="$route.path"></router-view>
            </keep-alive>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'

import Login from '@/views/Login'

export default {
  name: 'app',
  data () {
    return {
      drawer: false,
    }
  },
  computed: {
    ...mapState({
      'profile': (state) => state.user.detail && state.user.detail.profile
    })
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
      this.$router.replace({ name: 'login' })
    }
  },
  mounted() {
    this.$store.dispatch('loadOptions')
  },
  components: {
    'login-view': Login
  }
}
</script>

<style>
.center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
#back-button {
  position: fixed;
  left: 0;
  top: 0;
  width: 60px;
  height: 60px;
  padding: 12px;
  background: black;
  transform: translateY(-100%);

  transition: transform .5s;
}
#back-button:hover {
  cursor: pointer;
}
#back-button.shown {
  transform: translateY(0);
}
#inspire {
  background: white;
}
.page-enter-active {
  transition: opacity .3s ease-out, transform .3s ease-out;
}
.page-leave-active {
  transition: opacity .2s ease-in, transform .2s ease-in;
}
.page-enter, .page-leave-to {
  opacity: 0;
  transform: translateX(-20%);
}
</style>

<style scoped>
.main-action-buttons {
  margin: 0 -8px 16px;
}

.main-action-buttons .button-container {
  width: 25%;
  display: inline-block;
}

.main-action-buttons .button-container .button {
  margin: 8px;
  height: 100px;
  background: #f5f5f6;
  border-radius: 6px;

  display: flex;
  align-items: center;
  justify-content: center;
}

.main-action-buttons .button-container .button:hover {
  cursor: pointer;
}

@media screen and (max-width: 512px) {
  .main-action-buttons .button-container  {
    width: 40%;
  }
  .main-action-buttons {
    white-space: nowrap;
    overflow-x: scroll;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue